// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressResponse } from './address-response';

// @ts-ignore
import { BusinessPhonesResponse } from './business-phones-response';

/** See com.rev360.pms.api.controller.admin.general.location.AdminPracticeLocationDetailsResponse */
/* istanbul ignore next */
@GandalfModel
export class AdminPracticeLocationDetailsResponse extends GandalfModelBase {

	@GandalfProperty({ designType: AddressResponse })
	address!: AddressResponse | null;

	@GandalfProperty({ designType: String })
	barcodeIdentifier!: string | null;

	@GandalfProperty({ designType: Number })
	billingLocationClaimsId!: number | null;

	@GandalfProperty({ designType: Number })
	billingLocationStatementsId!: number | null;

	@GandalfProperty({ designType: String })
	billingProviderName!: string | null;

	@GandalfConstantDecorator(constants.ClaimNpiEntity)
	@GandalfProperty({ designType: constants.ClaimNpiEntity })
	claimNpiEntity!: constants.ClaimNpiEntity | null;

	@GandalfProperty({ designType: Number })
	coInsuranceTaxId!: number | null;

	@GandalfProperty({ designType: Number })
	coPayTaxId!: number | null;

	@GandalfProperty({ designType: Number })
	deductibleTaxId!: number | null;

	@GandalfProperty({ designType: Number })
	defaultFinanceChargePlanId!: number | null;

	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfProperty({ designType: String })
	facilityNumber!: string | null;

	@GandalfConstantDecorator(constants.FacilityType)
	@GandalfProperty({ designType: constants.FacilityType })
	facilityType!: constants.FacilityType | null;

	@GandalfProperty({ designType: String })
	fein!: string | null;

	@GandalfProperty({ designType: Number })
	logoPracticeFileId!: number | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: String })
	npi!: string | null;

	@GandalfProperty({ designType: AddressResponse })
	payToAddress!: AddressResponse | null;

	@GandalfProperty({ designType: BusinessPhonesResponse })
	phones!: BusinessPhonesResponse | null;

	@GandalfProperty({ designType: String })
	printNameAs!: string | null;

	@GandalfConstantDecorator(constants.BillingId)
	@GandalfProperty({ designType: constants.BillingId })
	providerBillingId!: constants.BillingId | null;

	@GandalfConstantDecorator(constants.ServiceLocationIndicator)
	@GandalfProperty({ designType: constants.ServiceLocationIndicator })
	serviceLocationIndicator!: constants.ServiceLocationIndicator | null;

	@GandalfProperty({ designType: String })
	storeNumber!: string | null;

	@GandalfProperty({ designType: String })
	websiteUrl!: string | null;

}
